import axios from "axios";
import { Modal, notification } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const API_BASE_URL = process.env.REACT_APP_LOKASI_URL;

// ==================== AXIOS INSTANCE ====================
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  withCredentials: true,   // ← Tambahkan ini
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("bigStore2.jwt");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(`🚀 Request to: ${config.url} | Token: ${token ? 'ADA' : 'TIDAK ADA'}`);
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`✅ Response OK: ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error(`❌ ERROR ${error.response?.status} on ${error.config?.url}`);
    console.error(error.response?.data);
    
    if (error.response?.status === 401) {
      Koneksiku.error("Sesi login expired atau token tidak valid.");
      Koneksiku.logout();
      setTimeout(() => window.location.href = "/", 800);
    }
    return Promise.reject(error);
  }
);

class Koneksiku {
  
  pesan3(pesan) {
    return new Promise((resolve) => {
        Modal.info({
            title: pesan,
            icon: <ExclamationCircleOutlined />,
            className: 'idpesan',            
            onOk() {
                resolve(1);
            },
          });
    });
  }

  tanya(pesan) {
    return new Promise((resolve) => {
        confirm({
            title: pesan,
            icon: <ExclamationCircleOutlined />,
            className: 'idpesan',
            onOk() {
                resolve(1);
            },
            onCancel() {
                resolve(0)
            },
          });
    });
  }

  pesan(pesan) {    
      notification['info']({
        message: <hr style={{height: '5px',backgroundColor: 'green',color: 'green'}}/>,
        description: pesan
      });
  }

  error(pesan) {    
      notification['error']({
        message: <hr style={{height: '5px',backgroundColor: 'red',color: 'red'}}/>,
        description: pesan
      });
  }

  pesan2(pesan) {
    Modal.confirm({
        cancelButtonProps: {
            disabled: true,
            style: {display: 'none'}
          },
        title: pesan,
        icon: <ExclamationCircleOutlined />,
        okText: 'Oke',
      });
  }

  dynamicSort(property) {
    return function (obj1, obj2) {
      return obj1[property] > obj2[property]
        ? 1
        : obj1[property] < obj2[property]
        ? -1
        : 0;
    };
  }

  dynamicSortMultiple() {
    var props = arguments;
    return function (obj1, obj2) {
      var i = 0,
        result = 0,
        numberOfProperties = props.length;
      while (result === 0 && i < numberOfProperties) {
        result = this.dynamicSort(props[i])(obj1, obj2);
        i++;
      }
      return result;
    };
  }

  // ====================== AXIOS METHODS (SUDAH DIPERBAIKI) ======================
  
  getAxio(alamat) {
    return api.get("/" + alamat)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.error("GET Error:", alamat, err.response?.data || err.message);
        throw err;
      });
  }

  postAxio(alamat, param1 = {}) {
    return api.post("/" + alamat, param1)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.error("POST Error:", alamat, err.response?.data || err.message);
        throw err;
      });
  }

  dapatAkses(dicari) {
    let k = localStorage.getItem("hakakses");
    if (k !== null && k !== undefined) {
      let hakakses = JSON.parse(k);
      return hakakses.some(el5 => el5.ket1.trim() === dicari);
    }
    return false;
  }

  getUrl = () => {
    return process.env.REACT_APP_LOKASI_URL;
  };

  getAxiosConfig = () => {
    return {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("bigStore2.jwt"),
        "Content-Type": "application/json;charset=UTF-8",
      },
    };
  };
  

  garisHori = (color) => (
    <hr style={{ color: color, backgroundColor: color, height: 4 }} />
  );


  getUser = () => {
    const kas2a = localStorage.getItem("bigStore2.user");
    if (kas2a !== null) {
      return { hasil: true, nilai: JSON.parse(kas2a) };
    } else {
      return { hasil: false };
    }
  };

  getInit = () => {
    const k = localStorage.getItem("init1");
    if (k !== null) {
      return { hasil: true, nilai: JSON.parse(k) };
    } else {
      return { hasil: false };
    }
  };

  getAkses = () => {
    const k = localStorage.getItem("hakakses");
    if (k !== null) {
      return { hasil: true, nilai: JSON.parse(k) };
    } else {
      return { hasil: false };
    }
  };

  getImageKu = () => {
    const k = localStorage.getItem("gambarku");
    if (k !== null) {
      return {
        hasil: true,
        gambar: k === '' ? '' : process.env.REACT_APP_LOKASI_IMAGE + '/' + k
      };
    } else {
      return { hasil: false };
    }
  };

  getLastLogin = () => {
    const k = localStorage.getItem("masukkelas");
    if (k !== null) {
      return { hasil: true, tgl: k };
    } else {
      return { hasil: false };
    }
  };

  logout() {
    localStorage.removeItem("masukkelas");
    localStorage.removeItem("bigStore2.user");
    localStorage.removeItem("bigStore2.jwt");
    localStorage.removeItem("hakakses");
    localStorage.removeItem("gambarku");
    localStorage.removeItem("init1");
    localStorage.removeItem("induk1");
    localStorage.removeItem("ini_sls");
    localStorage.removeItem("ini_logindirect");
  }

  // ====================== EXCEL HELPER METHODS ======================
  
  xl_tulis = (ws, baris, kolom, nilai) => {
    let sel = this.abjat(kolom);
    ws.getCell('"' + sel + baris + '"').value = nilai;
  };

  xl_tulis_tebal = (ws, baris, kolom, nilai) => {
    let sel = this.abjat(kolom);
    let cell = ws.getCell('"' + sel + baris + '"');
    cell.value = nilai;
    cell.font = { size: 13, bold: true };
  };

  xl_center = (ws, baris, kolom) => {
    let sel = this.abjat(kolom);
    ws.getCell('"' + sel + baris + '"').alignment = { vertical: 'top', horizontal: 'center' };
  };

  xl_center_area = (ws, awal_br, awal_kol, akhir_br, akhir_kol) => {
    for (let index = awal_kol; index <= akhir_kol; index++) {
      for (let index2 = awal_br; index2 <= akhir_br; index2++) {
        let sel = this.abjat(index);
        ws.getCell('"' + sel + index2 + '"').alignment = { vertical: 'top', horizontal: 'center' };
      }
    }
  };

  xl_center_area_wrap = (ws, awal_br, awal_kol, akhir_br, akhir_kol) => {
    for (let index = awal_kol; index <= akhir_kol; index++) {
      for (let index2 = awal_br; index2 <= akhir_br; index2++) {
        let sel = this.abjat(index);
        ws.getCell('"' + sel + index2 + '"').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      }
    }
  };

  xl_wrap = (ws, baris, kolom) => {
    let sel = this.abjat(kolom);
    ws.getCell('"' + sel + baris + '"').alignment = { wrapText: true, vertical: 'top', horizontal: 'left' };
  };

  xl_fullborder = (excel, awal_br, awal_kol, akhir_br, akhir_kol) => {
    for (let i = awal_br; i <= akhir_br; i++) {
      for (let i2 = awal_kol; i2 <= akhir_kol; i2++) {
        let sel = this.abjat(i2) + i;
        excel.getCell('"' + sel + '"').border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      }
    }
  };

  xl_border_bottom = (excel, awal_br, awal_kol, akhir_br, akhir_kol) => {
    for (let i = awal_br; i <= akhir_br; i++) {
      for (let i2 = awal_kol; i2 <= akhir_kol; i2++) {
        let sel = this.abjat(i2) + i;
        excel.getCell('"' + sel + '"').border = {
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      }
    }
  };

  xl_border_leftright = (excel, awal_br, awal_kol, akhir_br, akhir_kol) => {
    for (let i = awal_br; i <= akhir_br; i++) {
      for (let i2 = awal_kol; i2 <= akhir_kol; i2++) {
        let sel = this.abjat(i2) + i;
        excel.getCell('"' + sel + '"').border = {
          left: { style: 'thin' },
          right: { style: 'thin' }
        };
      }
    }
  };

  xl_OuterBorder = (worksheet, awal_br, awal_kol, akhir_br, akhir_kol) => {
    const borderStyle = { style: 'thin' };
    for (let i = awal_br; i <= akhir_br; i++) {
      const leftBorderCell = worksheet.getCell(i, awal_kol);
      const rightBorderCell = worksheet.getCell(i, akhir_kol);
      leftBorderCell.border = { ...leftBorderCell.border, left: borderStyle };
      rightBorderCell.border = { ...rightBorderCell.border, right: borderStyle };
    }
    for (let i = awal_kol; i <= akhir_kol; i++) {
      const topBorderCell = worksheet.getCell(awal_br, i);
      const bottomBorderCell = worksheet.getCell(akhir_br, i);
      topBorderCell.border = { ...topBorderCell.border, top: borderStyle };
      bottomBorderCell.border = { ...bottomBorderCell.border, bottom: borderStyle };
    }
  };

  xl_format_cell = (ws, baris, kolom, digit) => {
    let sel = this.abjat(kolom) + baris;
    if (digit === 0) {
      ws.getCell("'" + sel + "'").numFmt = '#,##0.00;[Red]-#,##0';
    } else if (digit === 1) {
      ws.getCell("'" + sel + "'").numFmt = '#,##0.00;[Red]-#,##0.0';
    } else if (digit === 2) {
      ws.getCell("'" + sel + "'").numFmt = '#,##0.00;[Red]-#,##0.00';
    }
  };

  xl_format_col = (ws, kolom, digit) => {
    if (digit === 0) {
      ws.getColumn(kolom).numFmt = '#,##0.00;[Red]-#,##0';
    } else if (digit === 1) {
      ws.getColumn(kolom).numFmt = '#,##0.00;[Red]-#,##0.0';
    } else if (digit === 2) {
      ws.getColumn(kolom).numFmt = '#,##0.00;[Red]-#,##0.00';
    }
  };

  xl_width = (ws, kolom, nilai) => {
    ws.getColumn(kolom).width = nilai;
  };

  xl_autowidht = (ws) => {
    ws.columns.forEach(function (column) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        var columnLength = cell.value ? cell.value.toString().length + 5 : 10;
        if (columnLength > maxLength) maxLength = columnLength;
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });
  };

  xl_right = (ws, baris, kolom) => {
    let sel = this.abjat(kolom);
    ws.getCell('"' + sel + baris + '"').alignment = { vertical: 'top', horizontal: 'right' };
  };

  xl_merge = (ws, awal_br, awal_kol, akhir_br, akhir_kol) => {
    let awal = this.abjat(awal_kol) + awal_br;
    let akhir = this.abjat(akhir_kol) + akhir_br;
    ws.mergeCells('"' + awal + '":"' + akhir + '"');
  };

  abjat = (num) => {
    var s = '', t;
    while (num > 0) {
      t = (num - 1) % 26;
      s = String.fromCharCode(65 + t) + s;
      num = (num - t) / 26 | 0;
    }
    return s || undefined;
  };
}

export default new Koneksiku();